import React from 'react'
import useStorage from '../../../firebase-hooks/useStorage'

function Progressbar( {imagePreviewUrl}) {

    // const { url } = useStorage(imagePreviewUrl) 

    return (
        <div className="progress-bar">
            Progress
        </div>
    )
}

export default Progressbar
